import getAppRoot from '../../utils/getAppRoot';
import { OrderDeliveryProgressDtoModelType, VisitEditedDtoModelType } from '../../models';
import SelectedVisitQuery from '../../queries/visits/SelectedVisitQuery';

export default ({ store, ...event }: VisitEditedDtoModelType | OrderDeliveryProgressDtoModelType) => async () => {
  const rootStore = getAppRoot(store);
  const projectId = rootStore.ui.selectedWorkspace?.id;
  const selectedOrder = rootStore.ui.selectedVisit;

  if (event.__typename === 'VisitEditedDto' && event.visit?.id) {
    store.customerOrderDtos.get(event.visit.id)?.updateDetails(event.visit);
  }

  const orderUuid = event.__typename === 'VisitEditedDto' ? event.visit?.uuid : event.orderUuid;
  if (projectId != null && selectedOrder != null && selectedOrder.uuid === orderUuid) {
    store.queryVisitById({ projectId, visitId: selectedOrder.id }, SelectedVisitQuery);
  }
};
